import { render, staticRenderFns } from "./OpenCardsList.vue?vue&type=template&id=77088c80&"
import script from "./OpenCardsList.vue?vue&type=script&lang=ts&"
export * from "./OpenCardsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports